rdefine('app/products/properties/Price',['backbone','text!products/prop/price.html'],function(Backbone,template) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'input-block-level',
        bindings:{
            /*el:{
                attr:{
                    placeholder:'model.name'
                },
                value:{
                    events:'change keyup',
                }
            }*/
            'input[name=current]':{
                value:{
                    events:'change keyup',
                }
            },
            'input[name=new_price]':{
                value:{
                    events:'change keyup',
                }
            }
        },
        initialize:function(options) {

            this.$el.html(Template7.compile(template)({currency:this.model.get('price_code')}));
            this.cform = options.cform;
            if(!this.cform.get('property_'+this.model.get("id"))) {
                this.cform.set('property_'+this.model.get("id"),{current:0,new_price:0});
            }

            this.bindings['input[name=current]'].value.data = 'cform.property_'+this.model.get("id") + ".current";
            this.bindings['input[name=new_price]'].value.data = 'cform.property_'+this.model.get("id") + ".new_price";
           // this.bindings.el.value.data = 'cform.property_'+this.model.get("id");
        }
    });
});